import * as yup from 'yup'

const schema = yup.object().shape({
  responsibles: yup.array().of(
    yup.object().shape({
      answerOptionTicketId: yup.number().required(),
      userIds: yup.array().of(
        yup.object().shape({
          id: yup.number().required(),
          name: yup.string().required(),
        }),
      ),
    }),
  ),
})

export default schema
